export class MenuConstant {
  static readonly menuIds = {};

  static readonly ITEM_MANAGER_TYPES = ['menu_items', 'product_items'];

  static readonly ITEM_MANAGER_COLUMNS = [
    'category',
    'production_area',
    'qty_limit',
    'unavailable',
    'price',
    'tax'
  ];

  static readonly LOADING_MODAL_MSG = {
    MENU_TALLY_LOADING: 'menu.loadingMenuPleaseWait',
    LOADING_ITEMS: 'menu.loadingItemsPleaseWait',
    MENU_TALLY_LOADING_LONGER: 'menu.loadingTakingLonger'
  };

  static readonly ITEM_MANGAGER_TYPE_LABELS_MAP: Record<string, string> = {
    menu_items: 'posManager.menuItems',
    product_items: 'posManager.productItems',
    product: 'common.product',
    menu: 'menu.title'
  };

  static readonly ITEM_MANAGER_COLUMN_LABELS_MAP: Record<string, string> = {
    category: 'posManager.category',
    production_area: 'posManager.productionArea',
    qty_limit: 'posManager.qtyLimit',
    unavailable: 'posManager.unavailable',
    price: 'posManager.price',
    tax: 'posManager.tax'
  };
}
